import {
  type OrchestratedOfferingListingDetails,
  type OrchestratedQuote,
} from '@b-stock/fe-core/bstock-next/queries'

import { MakeAnOfferFormProvider } from './MakeAnOfferFormProvider'
import { SimpleOfferActionModuleContent } from './SimpleOfferActionModuleContent'

export const SimpleOfferActionModule = ({
  listing,
  selectedQuote,
}: {
  listing: OrchestratedOfferingListingDetails
  selectedQuote?: OrchestratedQuote | null
}) => {
  return (
    <MakeAnOfferFormProvider listing={listing} selectedQuote={selectedQuote}>
      <SimpleOfferActionModuleContent
        listing={listing}
        selectedQuote={selectedQuote}
      />
    </MakeAnOfferFormProvider>
  )
}
